import { ComponentProps, ReactNode, Ref } from 'react'

import { AstraTooltip } from '~/astra'
import { ButtonTag, getColorFromType } from '~/components'
import env from '~/env'

import { PractitionerActivityDragItem, useOptionalDraggable } from '../../../dndData'

type ButtonTagProps = ComponentProps<typeof ButtonTag>

type Props = {
    tooltip?: string
    dragItem?: PractitionerActivityDragItem
    colorType: ButtonTagProps['colorType']
    isGrayedOut?: boolean
    whiteText?: boolean
    label?: string
    isLoading?: boolean
    endContent?: ReactNode
    ref?: Ref<HTMLDivElement>
}

export const ActivityTag = ({ ref, tooltip, colorType, whiteText, isLoading, isGrayedOut, label, dragItem, endContent }: Props) => {
    const { isDragging, ref: draggingRef } = useOptionalDraggable(dragItem)

    const isDraggingStyles = isDragging ? 'opacity-30 pointer-events-none shadow-sm' : ''
    const grayedOutStyles = isGrayedOut ? 'opacity-30' : ''

    return (
        <div className="inline-flex w-full" ref={ref}>
            <AstraTooltip tooltipContent={!env.VITE_NO_UNSTABLE_EFFECTS ? tooltip : null} noWrapText>
                <ButtonTag
                    ref={draggingRef}
                    isLoading={isLoading}
                    tabIndex={-1}
                    colorType={colorType}
                    whiteText={whiteText}
                    fillType="all"
                    style={{ borderColor: `color-mix(in srgb, ${getColorFromType(colorType)} 90%, black)` }}
                    className={`activity-tag !min-w-[20px] overflow-hidden text-clip whitespace-nowrap transition-opacity duration-200 ${isDraggingStyles} ${grayedOutStyles}`}
                    label={label ?? ''}
                    endContent={endContent}
                />
            </AstraTooltip>
        </div>
    )
}
